/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  document.querySelectorAll(".metafileds_description_wrapper .tab_header").forEach((tab) => {
    tab.addEventListener("click", () => {
      const tabName = tab.getAttribute("data-tab");
      const displayedTabHeader = document.querySelector(".metafileds_description_wrapper .tab_header.selected");
      const displayedTabContent = document.querySelector(".metafileds_description_wrapper .tab_content.selected");
      const selectedTabContent = document.querySelector(`.metafileds_description_wrapper .tab_content[data-tab='${tabName}']`);

      displayedTabHeader.classList.remove("selected");
      displayedTabContent.classList.remove("selected");
      selectedTabContent.classList.add("selected");
      tab.classList.add("selected");
    });
  });

  function hidePrice() {
    let isBadItem = false;
    const cartItems = document.querySelectorAll(".cart__item");
    for (const item of cartItems) {
      const title = item.querySelector(".cart__item__title a").innerText;
      if (title == "Trousse personnalisée") {
        isBadItem = true;
        break;
      }
    }

    if (isBadItem) {
      const styles = "";
      // `
      //   .cart__item .cart__price {
      //     display: none;
      //   }
    
      //   .cart__total, .cart__note, .cart__message {
      //     display: none;
      //   }
      // `
  
      const styleSheet = document.createElement("style");
      styleSheet.innerText = styles;
      document.head.appendChild(styleSheet);
    }
  }
  hidePrice();

  document.querySelector(".header__desktop__buttons div:last-of-type").addEventListener("click", () => {
    setTimeout(() => {
      hidePrice();
    }, 250);
  });

  document.querySelector(".header__mobile__right div:last-of-type").addEventListener("click", () => {
    setTimeout(() => {
      hidePrice();
    }, 250);
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
